export const comparisonData = [
  { rank: 1, name: 'Mulebuy Spreadsheet Pro', speed: 'High', accuracy: 'High', usability: 'Easy', score: 9.8 },
  { rank: 2, name: 'Mulebuy Spreadsheet Lite', speed: 'High', accuracy: 'High', usability: 'Medium', score: 9.4 },
  { rank: 3, name: 'Mulebuy Spreadsheet Basic', speed: 'Medium', accuracy: 'High', usability: 'Easy', score: 9.1 },
  { rank: 4, name: 'Alternative System D', speed: 'Medium', accuracy: 'Medium', usability: 'Easy', score: 8.7 },
];

export const seoStats = [
  { value: '14+', label: 'Categories' },
  { value: '2026', label: 'Updated' },
  { value: '100K+', label: 'Users' },
  { value: '99%', label: 'Accuracy' },
];

export const features = [
  'Structured Product Tracking',
  'Supplier Comparison Workflows',
  'Data Consolidation',
  'Efficiency Optimization',
];

export const searchIntents = [
  'What is Mulebuy spreadsheet?',
  'Best Mulebuy spreadsheet 2026',
  'Is Mulebuy spreadsheet safe?',
  'Mulebuy spreadsheet comparison',
  'How to use Mulebuy spreadsheet',
];

export const safetyNotes = [
  'Some Mulebuy spreadsheet sources may become outdated',
  'Third-party tools are not controlled by this platform',
  'Data accuracy may vary across providers',
  'Users should always verify before making decisions',
];

export const footerLinks = {
  categories: [
    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Hoodies', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
  ],
  resources: [
    { name: 'Beginners Guide', url: '/article/mulebuy-spreadsheet-beginners-guide' },
    { name: 'Safety Tips', url: '/article/mulebuy-spreadsheet-safety-tips' },
    { name: 'Best Practices', url: '/article/mulebuy-spreadsheet-best-practices' },
    { name: 'Expert Review', url: '/article/mulebuy-spreadsheet-expert-review' },
  ],
  guides: [
    { name: 'Efficiency Hacks', url: '/article/mulebuy-spreadsheet-efficiency-hacks' },
    { name: 'Data Management', url: '/article/mulebuy-spreadsheet-data-management' },
    { name: 'Common Mistakes', url: '/article/mulebuy-spreadsheet-common-mistakes' },
    { name: 'Update Guide 2026', url: '/article/mulebuy-spreadsheet-update-guide' },
  ],
  legal: [
    { name: 'Privacy Policy', url: '/' },
    { name: 'Terms', url: '/' },
    { name: 'Contact', url: '/' },
  ],
};